module.exports = {"message":{"text":"Good good study, Day day up"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs/en/en.json
// module id = SkWv
// module chunks = 4